/**
 * Redirects from every pre-2026-10-16 address (moved out of App.tsx in 0.53.0 so they can be
 * tested): /identity/..., /system/..., /history and the other old Retail domains go to the same path
 * under /retail; /org/branches and /org/regions go to the Shared area. Query string and hash kept.
 */

import { Navigate, useLocation } from 'react-router';

/** Old top-level Retail path -> the same path under /retail (query and hash kept). */
export function ToRetail(): JSX.Element {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={`/retail${pathname}${search}${hash}`} replace />;
}

/** Old /org/branches, /org/regions -> the Shared area (branches and regions moved there). */
export function OrgToShared(): JSX.Element {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.replace(/^\/org\/?/, '');
  return <Navigate to={`/shared/${rest || 'branches'}${search}${hash}`} replace />;
}

export const LEGACY_RETAIL_DOMAINS = [
  'history',
  'identity',
  'products',
  'system',
  'reference',
  'notifications',
  'workflow',
  'documents',
  'compliance',
] as const;
